import cx from 'clsx';
import React from 'react';

import CarouselSlider from '@/components/Carousel/Slider/Slider';
import ArrowRight from '@/components/icons/ArrowRight';
import { ExtendedCategoryItem } from '@/components/NavigationContent/types';
import SectionHeader from '@/components/SectionHeader/SectionHeader';
import { createSearchQuery } from '@/logic/main/utils';

import styles from './Card.module.scss';

interface CardCategoryPropTypes {
  items?: ExtendedCategoryItem[];
  handleItemClick: (
    event: React.MouseEvent<HTMLAnchorElement | HTMLDivElement>,
    item: ExtendedCategoryItem
  ) => void;
  title?: string;
  displayList?: boolean;
}

const Card: React.FC<CardCategoryPropTypes> = ({
  items,
  handleItemClick,
  title,
  displayList,
}) => {
  if (!items || !items.length) return null;
  const mappedCardItems = items.map((item, index) => {
    const dynamicProps = {
      ...(item.colour && { style: { backgroundImage: item.colour } }),
    };
    return (
      <div
        data-testid="item"
        key={index}
        className={cx(
          displayList ? styles.listWrapper : styles.carouselWrapper,
          index % 2 ? styles.wrapperBlue : styles.wrapperOrange
        )}
        {...dynamicProps}
      >
        <a
          className={styles.subInfoWrapper}
          href={item.route_link ? item.route_link : item.url || ''}
          target={item.target || ''}
          rel={`${item.notIndexed ? 'nofollow' : ''}`}
          onClick={e => handleItemClick(e, item)}
          data-testid="link-anchor"
        >
          <img
            data-testid="image"
            className={styles.icon}
            src={
              item.image?.source
                ? `${item.image.source}${
                    !item.image.source.includes('.svg')
                      ? createSearchQuery({
                          width: 24,
                          quality: 80,
                          format: 'webply',
                        })
                      : ''
                  }`
                : ''
            }
            alt={item.image?.alt || ''}
          />
          <p className={styles.title}>{item.title}</p>
          <div className={styles.explore}>
            <span className={styles.subtitle}>{item.description} </span>
            <ArrowRight className={styles.arrowWrapper} data-testid="arrow" />
          </div>
        </a>
      </div>
    );
  });

  return (
    <div className={cx(displayList && styles.linkListWrapper)}>
      <SectionHeader heading={title} data-testid="title" />
      <div
        className={cx(
          displayList ? styles.listCategoryWrapper : styles.categoryWrapper
        )}
        data-testid="card-wrapper"
      >
        {displayList ? (
          <div>{mappedCardItems}</div>
        ) : (
          <CarouselSlider styleProp={'slider'} edgeSlidesPadding={7}>
            {mappedCardItems}
          </CarouselSlider>
        )}
      </div>
    </div>
  );
};

export default Card;
